import { useEffect, useRef, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

export default function CustomCKEditor({ value = "", onChange = () => {}, customConfig = {} }) {
  const editorContainerRef = useRef(null);
  const wordCountRef = useRef(null);
  const [editorHtml, setEditorHtml] = useState(value);
  const [isLayoutReady, setIsLayoutReady] = useState(false);

  useEffect(() => {
    setIsLayoutReady(true);
    return () => setIsLayoutReady(false);
  }, []);

  useEffect(() => {
    if (wordCountRef.current) {
      const text = editorHtml.replace(/<[^>]+>/g, "").trim();
      const words = text.split(/\s+/).filter(Boolean);
      wordCountRef.current.innerText = `${words.length} words`;
    }
  }, [editorHtml]);

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }],
      [{ font: [] }, { size: [] }],
      [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ align: [] }],
      ["link", "image", "code-block", "blockquote"],
      ["clean"]
    ],
    ...customConfig.modules
  };

  const formats = [
    "header",
    "bold", "italic", "underline", "strike",
    "color", "background",
    "font", "size",
    "list", "bullet", "check",
    "indent", "align",
    "link", "image", "code-block", "blockquote"
  ];

  return (
    <div className="main-container">
      <div
        className="editor-container editor-container_classic-editor editor-container_include-style editor-container_include-word-count editor-container_include-fullscreen"
        ref={editorContainerRef}
      >
        <div className="editor-container__editor">
          <ReactQuill
            theme="snow"
            value={editorHtml}
            onChange={(content) => {
              setEditorHtml(content);
              onChange(content);
            }}
            modules={modules}
            formats={formats}
            placeholder="Type or paste your content here!"
          />
        </div>
        <div className="editor_container__word-count" ref={wordCountRef}></div>
      </div>
    </div>
  );
}
